<script lang="ts" setup>
import { ref } from "vue";
import OmniTextarea from "@/components/omni/OmniTextarea.vue";
import { useI18n } from "vue-i18n";

const model = defineModel<string>({ required: true });

const { t } = useI18n();

const isReadonly = ref(true);

function enableEdit() {
  isReadonly.value = false;
}
</script>

<template>
  <div class="order-field">
    <div class="d-flex align-center mb-2">
      <slot name="title" />

      <v-btn
        v-if="isReadonly"
        class="ml-3"
        color="primary"
        prepend-icon="mdi-pencil-outline"
        size="small"
        variant="outlined"
        @click="enableEdit"
      >
        <span class="font-weight-500">
          {{ t("general.edit") }}
        </span>
      </v-btn>
    </div>

    <omni-textarea
      v-model="model"
      :class="['order-field__input pa-3 border-grey-lighter-1 rounded', { 'bg-grey-lighten-4': isReadonly }]"
      :readonly="isReadonly"
      hide-close
      variant="plain"
    />
  </div>
</template>

<style lang="scss" scoped>
.order-field__input {
  :deep(.v-field__input) {
    padding: 0;
    margin: 0;
  }

  min-height: 100px;
}
</style>
